import React from 'react';

const User = () => {
    return (
        <div>
            <h2 className="text-3xl">Users PAGE</h2>
        </div>
    );
};

export default User;